<template>
  <v-col cols="12" id="top-bar" class="px-0">
    <v-row class="pa-0 px-md-4 py-1 top-bar-wrap w-100" justify="space-between" align="center">
      <v-col cols="auto" class="px-0 px-sm-2" align="start" v-if="this.$route.name != 'home'">
        <v-btn
            icon
            tile
            small
            color="#7764CA"
            class="float-left mr-2"
            @click="$router.go(-1)"
            v-if="this.$route.name === 'profile' || this.$route.name === 'books' || this.$route.name === 'articles' || this.$route.name === 'ranking'"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        <h3 class="text-nowrap">{{ $t( 'home.'+ this.$route.name) }}</h3>
      </v-col>
      <v-col cols="auto" fill-height class="pa-0 transition-all" v-if="this.$route.name == 'home' && $vuetify.breakpoint.xs">
        <v-img contain :src="logo" width="90" class=""></v-img>
      </v-col>
      <v-col class="greet-text text-left text-nowrap"  v-if="this.$route.name == 'home' && !$vuetify.breakpoint.xs">
        {{ $t('home.greet') }}, <b>{{ user.firstname}}!</b>
      </v-col>
      <v-spacer></v-spacer>
      <!-- <v-col cols="auto" md="6" class="px-0 pl-md-2" align="end" v-if="showUsernam⁄eAndInfo"> -->
      <v-col
        cols="auto"
        md="6"
        class="d-flex justify-content-end"
        align="end"
        >
        <div elevation="0" class="mx-2 mx-md-3 btn-awards">
          <v-img
            :src="beecoins"
            max-height="25"
            max-width="25"
          ></v-img>
          <span class="btn-label ml-1 font-weight-bold">{{userBeecoins}}</span>
        </div>
        <v-badge
          color="#E86B59"
          dot
          offset-x="7"
          offset-y="7"
          v-if="notifications.length"
        >
          <v-btn
            data-cy="avatar-icon-topBar-btn"
            icon
            elevation="0"
            color="primary"
            class="pa-1"
            @click="showPerfil">
            <AvatarIcon :avatar="stUserAvatar" :height=36 :width=36 v-if="stUserAvatar"></AvatarIcon>
            <AvatarIcon v-else></AvatarIcon>
          </v-btn>
        </v-badge>
        <v-btn v-else icon elevation="0" color="primary" class="pa-1">
            <AvatarIcon :avatar="stUserAvatar" v-if="stUserAvatar"></AvatarIcon>
            <AvatarIcon v-else></AvatarIcon>
        </v-btn>
      </v-col>
    </v-row>
    <MessageModal
      :dialog="true"
      :message_data="currentMessage"
      v-if="currentMessage"
      @close-modal="closeMessage"
    />
  </v-col>
</template>

<script>
/* eslint-disable global-require */

import { mapState } from 'vuex'

import MessageService from '@/services/message'

import AvatarIcon from './AvatarIcon.vue'
import MessageModal from './modals/MessageModal.vue'

export default {
  components: {
    AvatarIcon,
    MessageModal,
  },
  computed: {
    ...mapState({
      user: (state) => state.userData.user,
      existAssignedBook: (state) => state.userData.existAssignedBook,
      assignedBookId: (state) => state.userData.assignedBookId,
      messages: (state) => state.userData.recievedMessages,
      stUserAvatar: (state) => state.userData.avatarSelected,
      userBeecoin: (state) => state.userData.coins,
    }),
    username() {
      return this.setName(this.user)
    },
    showUsername() {
      return this.$router.currentRoute.path !== '/user/profile'
    },
    // showUsernameAndInfo() {
    //   return this.$router.currentRoute.path !== '/user/store'
    // },
    userBeecoins() {
      return this.userBeecoin
    }
  },
  watch: {
    existAssignedBook(newValue) {
      if (newValue) {
        this.notifications[0].show = true
        this.notifications[0].to = `/user/book/${this.assignedBookId}`
      }
    },
  },
  data() {
    return {
      logo: require('@/assets/img/brand/logo.svg'),
      calendar: require('@/assets/img/icons/calendar.png'),
      beecoins: require('@/assets/img/icons/beecoins.png'),
      beecoinsCount: 1600,
      messagesMenu: false,
      notificationsMenu: false,
      userMenu: false,
      currentMessage: null,
      showMessage: false,
      notifications: [
        {
          icon: '/img/user/reminder.svg',
          title: 'Recordatorio',
          value: 'bookAssigment',
          desc: this.$t('home.notification_text_1'),
          to: `/user/book/${this.assignedBookId}`,
          show: this.existAssignedBook,
          read: false,
        },
        {
          icon: '/img/user/store.svg',
          title: 'Novedades de tu tienda',
          value: 'store',
          show: true,
          to: '/user/store',
          desc: this.$t('home.notification_text_2'),
          read: false,
        },
        {
          icon: '/img/user/library.svg',
          title: 'Novedades de la biblioteca',
          value: 'library',
          show: true,
          to: '/user/library',
          desc: this.$t('home.notification_text_3'),
          read: false,
        },
      ],
    }
  },
  methods: {
    getRemaingTime(date = '') {
      return this.$moment(date).fromNow()
    },
    openMessage(data) {
      this.currentMessage = data
      this.messagesMenu = false
      this.showMessage = true
    },
    closeMessage() {
      this.showMessage = false
      // MessageService.setReadMessages({ idList: [this.currentMessage.id] })
      // const found = this.messages.find((i) => i.message.id === this.currentMessage.id)
      // this.messages.splice(this.messages.indexOf(found), 1)
      this.currentMessage = null
    },
    redirectTo(to = '') {
      this.notificationsMenu = !this.notificationsMenu

      // Avoid redundant navigation
      if (to && this.$router.history.current.path !== to) this.$router.push(to)
    },
    setName(data) {
      return `${this.capitalizeText(data.firstname.split(' ')[0])} ${this.capitalizeText(
        data.lastname.split(' ')[0]
      )}`
    },
    capitalizeText(text) {
      return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
    },
    showPerfil() {
        this.$root.$emit('profileDrawer')
    },
  },
}
</script>
<style lang="scss">

/* .topbar{
  //margin: auto;
  //width: calc(100% - 24px);
  widows:  100%;
}
.color-primary {
  color: #514773;
}

.v-list-item,
.v-list-item:before {
  border-radius: 10px;
}

.v-list-item:hover {
  background-color: #f3efff;
}

.v-menu__content {
  background-color: #ffff;
  border-radius: 10px;
}

.my-menu {
  contain: initial;
  overflow: visible;
}

.my-menu:after {
  // This is the shadow triangle
  position: absolute;
  top: -22px;
  right: 145px;
  content: '';
  width: 0;
  height: 0;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-bottom: 22px solid rgba(0, 0, 0, 0.03);
  z-index: 1;
}
.my-menu::before {
  position: absolute;
  content: '';
  top: 0;
  right: 150px;
  transform: translateY(-100%);
  width: 15px;
  height: 20px;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  border-bottom: 20px solid #fff;
  z-index: 2;
}

.my-profile {
  contain: initial;
  overflow: visible;
}

.my-profile:after {
  // This is the shadow triangle
  position: absolute;
  top: -22px;
  right: 19px;
  content: '';
  width: 0;
  height: 0;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-bottom: 22px solid rgba(0, 0, 0, 0.03);
  z-index: 1;
}
.my-profile::before {
  position: absolute;
  content: '';
  top: 0;
  right: 24px;
  transform: translateY(-100%);
  width: 15px;
  height: 20px;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  border-bottom: 20px solid #fff;
  z-index: 2;
}
.pending-icon{
  background-color: #E86B59;
  border-radius: 10px;
  height: 10px;
  position: absolute;
  top: 8px;
  right: 8px;
  width: 10px;
}
.btn-label{
  letter-spacing: .8px;
} */
#top-bar{
  padding-left: 0;
  .top-bar-wrap{
    background-color: #fff;
    border-radius: 1em;
    margin-left: 0;
    @media screen and (min-width: 600px) {
      box-shadow: 0px 0px 60px 0px #0000000D;
    }
  }
}
.greet-text{
  font-size: 1.5em;
  @media screen and (max-width: 900px) {
    font-size: 1.2em;
  }
}
.btn-awards{
  align-items: center;
  background-color: #F7F8F9;
  border-radius: 8px;
  display: inline-flex;
  padding: 4px 8px;
  * {
    display: inline-block;
    vertical-align: middle;
  }
}
</style>
